
import Vue from "vue";
import { ChatMessage } from "@/utils/chat-message";
import AppTimeago from "@/components/common/Timeago.vue";
import { ChatMessageFile } from "../../utils/chat-message-file";
import { autoLink } from "../../utils/auto-link";
import { specialLink } from "../../utils/special-link";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>ChatMessage,
			required: true
		}
	},
	computed: {
		images():ChatMessageFile[] {
			return this.value.files.filter(f=>f.isImage());
		},
		otherFiles():ChatMessageFile[] {
			return this.value.files.filter(f=>!f.isImage());
		},
		content():string{
			return specialLink(autoLink(this.value.message));
		}
	},
	methods: {
		onImageClick(img:ChatMessageFile){
			if (img.onFileClick){
				img.onFileClick();
			}else{
				window.open(img.fileUrl);
			}
		},
		onFileClick(file:ChatMessageFile){
			if (file.onFileClick){
				file.onFileClick();
			}else{
				let link = document.createElement("a");
				link.download = file.fileName;
				link.href = file.fileUrl;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	},
	components: {
		AppTimeago
	}
});
